import React, { memo } from 'react';
import {
  useSnackbar,
  Snackbar as FrontonSnackbar,
  Snack,
  SnackButton,
  SnackCloseButton,
  Icon,
} from 'fronton-react';
import { SnackbarProps } from 'fronton-react/snackbar/types';
import { WarningIcon } from '@fronton/icons-react';

export const Snackbar = memo(
  ({
    horizontalPosition = 'center',
    verticalPosition = 'top',
  }: {
    horizontalPosition?: SnackbarProps['horizontalPosition'];
    verticalPosition?: SnackbarProps['verticalPosition'];
  }) => {
    const { state, removeSnack } = useSnackbar();

    return (
      <FrontonSnackbar horizontalPosition={horizontalPosition} verticalPosition={verticalPosition}>
        {state.map(({ id, title, content, type, button, closeButton, time, timeout = 3000, wide, icon }) => (
          <Snack
            key={id}
            id={id}
            header={title}
            paragraph={content}
            variant={type}
            wideButton={wide}
            icon={
              icon ? (
                <Icon size={24}>
                  <WarningIcon type="outline" color="control-invert" />
                </Icon>
              ) : undefined
            }
            autoHideTimer={time ? timeout : undefined}
            closeButton={closeButton ? <SnackCloseButton onClick={() => removeSnack(id)} /> : undefined}>
            {button && <SnackButton onClick={() => removeSnack(id)}>Закрыть</SnackButton>}
          </Snack>
        ))}
      </FrontonSnackbar>
    );
  }
);
